import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import Con from '../../static/config.json'

Vue.use(Vueaxios, axios)
const URL = Con.URL
export default {
  processInvice (obj, header, success, error) {
    Vue.axios.post(URL + 'invoice/updateinvoicebyid', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  backUpDB (success, error) {
    Vue.axios.get(URL + 'backup/db').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  invoiceMonth (header, date, success, error) {
    Vue.axios.get(URL + 'invoice/generateinvoice/' + date, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  UpdateinvoiceMonth (header, date, success, error) {
    Vue.axios.get(URL + 'invoice/updateinvoice/' + date, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  CentralinvoiceMonth (header, date, success, error) {
    Vue.axios.get(URL + 'historyincome/generatecentralvalue/' + date, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_process.js